import { render, staticRenderFns } from "./RankItem.vue?vue&type=template&id=dfda3d34&scoped=true&"
import script from "./RankItem.vue?vue&type=script&lang=js&"
export * from "./RankItem.vue?vue&type=script&lang=js&"
import style0 from "./RankItem.vue?vue&type=style&index=0&id=dfda3d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfda3d34",
  null
  
)

export default component.exports